/** Test ids of the print package header's Edit Case control and its modal. */
export const PRINT_PACKAGE_HEADER_TEST_IDS = {
  EDIT_CASE: 'print-package-edit-case',
  CASE_DETAILS_MODAL: 'print-package-case-details-modal',
} as const
